module.exports = __webpack_public_path__ + "static/img/downloadpopupgold2.f79a21c4.webp";